import { CtPreference } from './ctPreference';

export type CaptureFilter = {
  dateDestination: { start: Date | string; end: Date | string };
  bldate: { start: Date | string; end: Date | string };
  regionIds: string[];
};

export const getDefaultFilter = (): CaptureFilter => {
  const today = new Date();
  const oneWeekAgo: Date = new Date(today.setDate(today.getDate() - 7));
  const inOneWeek: Date = new Date(today.setDate(today.getDate() + 7));

  return {
    dateDestination: {
      start: null,
      end: null,
    },
    bldate: {
      start: oneWeekAgo,
      end: inOneWeek,
    },
    regionIds: [],
  };
};

export interface ColumnFilters {
  [key: string]: { label: string; value: any }[];
}

export interface FilterPreference {
  [key: string]: CtPreference;
}

export type PreferencePayload = {
  captureFilter: CaptureFilter;
  columnFilter: ColumnFilters;
};
